<sim-assessable-group-panel [type]="AssessablePanelType.Checklist">
	<ng-template assessableItemTemplate [assessable]="assessable()" let-data>
		<sim-checklist-item [data]="data" [compactLayout]="false" [isInArchive]="isInArchive()" />
	</ng-template>
</sim-assessable-group-panel>
